import { useQuery } from '@tanstack/vue-query';
import { sortAlphabeticallyBy } from '~/utils';
import { unwrapResponse } from '~/utils/unwrapResponse';

export type UseMerchantsQueryOptions = {
	enabled?: MaybeRef<boolean>;
};

export const fetchMerchantsFn = () => {
	const { $api } = useNuxtApp();
	return $api.GET('/merchants')
		.then(unwrapResponse)
		.then((data) => data?.toSorted(sortAlphabeticallyBy('name')));
};

export const useMerchantsQuery = (options?: UseMerchantsQueryOptions) => {
	const enabled = computed(() => unref(options?.enabled) ?? true);

	const query = useQuery({
		queryKey: ['merchants'],
		queryFn: fetchMerchantsFn,
		enabled,
	});

	return query;
};
